import { validateRequired } from '../../../../core/validators';

const directApplication = {
  motivation: [validateRequired('motivation')()],
  availability: [validateRequired('availability')()],
};

export { directApplication };
